// extracted by mini-css-extract-plugin
export default {"wrapper":"Policy_wrapper__LC6z7","main":"Policy_main__R9xiH"};